/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online text repeater. Repeat any word, line, or block of text a chosen number of times, joined by a new line, space, comma, or custom separator. Works in your browser.`)
};

const es_tr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de texto gratuito en línea. Repite cualquier palabra, línea o bloque de texto un número elegido de veces, unidos por un salto de línea, espacio, coma o separador personalizado. Funciona en tu navegador.`)
};

const de_tr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Textwiederholer. Wiederholen Sie ein beliebiges Wort, eine Zeile oder einen Textblock eine gewählte Anzahl von Malen, verbunden durch neue Zeile, Leerzeichen, Komma oder ein eigenes Trennzeichen. Funktioniert direkt im Browser.`)
};

const nl_tr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online tekstherhaler. Herhaal elk woord, regel of tekstblok een aantal keer naar keuze, samengevoegd door een nieuwe regel, spatie, komma of aangepast scheidingsteken. Werkt in je browser.`)
};

const fr_tr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répéteur de texte gratuit en ligne. Répétez n'importe quel mot, ligne ou bloc de texte un nombre choisi de fois, séparé par une nouvelle ligne, un espace, une virgule ou un séparateur personnalisé. Fonctionne dans votre navigateur.`)
};

const it_tr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetitore di testo gratuito online. Ripeti qualsiasi parola, riga o blocco di testo un numero di volte scelto, unito da una nuova riga, uno spazio, una virgola o un separatore personalizzato. Funziona nel tuo browser.`)
};

const pt_br2_tr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de texto online gratuito. Repita qualquer palavra, linha ou bloco de texto um número escolhido de vezes, unido por uma nova linha, espaço, vírgula ou separador personalizado. Funciona no seu navegador.`)
};

const pt_tr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetidor de texto online gratuito. Repita qualquer palavra, linha ou bloco de texto um número escolhido de vezes, unido por uma nova linha, espaço, vírgula ou separador personalizado. Funciona no seu navegador.`)
};

const ja_tr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインテキストリピーター。任意の単語、行、またはテキストブロックを選択した回数だけ繰り返し、改行、スペース、カンマ、またはカスタムセパレーターで結合します。ブラウザで実行されます。`)
};

const zh_tr_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线文本重复器。将任意单词、行或文本块按所选次数重复，并用换行、空格、逗号或自定义分隔符连接。可在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_meta_description", locale)
	if (locale === "en") return en_tr_meta_description(inputs)
	if (locale === "es") return es_tr_meta_description(inputs)
	if (locale === "de") return de_tr_meta_description(inputs)
	if (locale === "nl") return nl_tr_meta_description(inputs)
	if (locale === "fr") return fr_tr_meta_description(inputs)
	if (locale === "it") return it_tr_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_tr_meta_description(inputs)
	if (locale === "pt") return pt_tr_meta_description(inputs)
	if (locale === "ja") return ja_tr_meta_description(inputs)
	return zh_tr_meta_description(inputs)
};